import React from "react";
import { Container } from "./styles";
import { useHistory } from "react-router-dom";

const MAX_NON_HERO_PLUGINS = 4;

export default function Plugins({ plugins }) {
  const history = useHistory();

  if (!plugins || plugins.length === 0) {
    plugins = [{
      name: "Series Idea Generator [3]",
      description: "This plugin builds an audience profile for your desired genre so you can better understand your market. To use it, set your genre within your Story Bible. You may also optionally provide up to three reference books in that genre to help achieve a more targeted profile—just write those titles along with their authors into a document and highlight them before running this plugin. For the best results, run the Market Research by Genre [1] plugin first, and after inserting that output into a doc, highlight it.."
    },{
      name: "Series Idea Generator [3]",
      description: "This plugin builds an audience profile for your desired genre so you can better understand your market. To use it, set your genre within your Story Bible. You may also optionally provide up to three reference books in that genre to help achieve a more targeted profile—just write those titles along with their authors into a document and highlight them before running this plugin. For the best results, run the Market Research by Genre [1] plugin first, and after inserting that output into a doc, highlight it.."
    },{
      name: "Series Idea Generator [3]",
      description: "This plugin builds an audience profile for your desired genre so you can better understand your market. To use it, set your genre within your Story Bible. You may also optionally provide up to three reference books in that genre to help achieve a more targeted profile—just write those titles along with their authors into a document and highlight them before running this plugin. For the best results, run the Market Research by Genre [1] plugin first, and after inserting that output into a doc, highlight it.."
    },{
      name: "Series Idea Generator [3]",
      description: "This plugin builds an audience profile for your desired genre so you can better understand your market. To use it, set your genre within your Story Bible. You may also optionally provide up to three reference books in that genre to help achieve a more targeted profile—just write those titles along with their authors into a document and highlight them before running this plugin. For the best results, run the Market Research by Genre [1] plugin first, and after inserting that output into a doc, highlight it.."
    },{
      name: "Series Idea Generator [3]",
      description: "This plugin builds an audience profile for your desired genre so you can better understand your market. To use it, set your genre within your Story Bible. You may also optionally provide up to three reference books in that genre to help achieve a more targeted profile—just write those titles along with their authors into a document and highlight them before running this plugin. For the best results, run the Market Research by Genre [1] plugin first, and after inserting that output into a doc, highlight it.."
    },{
      name: "Series Idea Generator [3]",
      description: "This plugin builds an audience profile for your desired genre so you can better understand your market. To use it, set your genre within your Story Bible. You may also optionally provide up to three reference books in that genre to help achieve a more targeted profile—just write those titles along with their authors into a document and highlight them before running this plugin. For the best results, run the Market Research by Genre [1] plugin first, and after inserting that output into a doc, highlight it.."
    },];
  }

  const goToPlugin = (plugin) => {
    return (e) => {
      history.push(`/app/plugin/${plugin.shortId}/${plugin.slug}`);
    };
  };

  return (
    <Container>
      {plugins?.slice(0, 4).map((plugin) => { // Only take the first 4 plugins
        // Helper function to truncate the description
        const truncateDescription = (description) => {
          const words = description.split(' ');
          if (words.length > 15) { // Truncate to 15 words and add "..."
            return words.slice(0, 15).join(' ') + '...';
          }
          return description;
        };

        return (
          <div
            className="plugin"
            onClick={goToPlugin(plugin)} // Ensure onClick is a function call
          >
            <h3>{plugin.name}</h3>
            <p>{truncateDescription(plugin.description)}</p>
          </div>
        );
      })}
    </Container>
  );
}
